import { Loading } from "@mnk/frontend/components/Loading";
import { ItemList } from "@mnk/frontend/components/domain/items/List";
import { trpc } from "@mnk/frontend/lib/trpc";
import { NotFound } from "@mnk/frontend/pages/NotFound";
import type { GetItem } from "@mnk/shared/models/item";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const OfficeDetail = () => {
  const [items, setItems] = useState<GetItem[]>([]);

  const { id } = useParams();

  const getOffice = trpc.getOffice.useQuery({ id: id ?? "" });
  const office = getOffice.data;

  const getItems = trpc.getRootItems.useQuery({ officeId: office?.id ?? "" }, { enabled: !!office });

  const afterCreateItem = () => {
    getItems.refetch();
  };

  useEffect(() => {
    if (getItems.data) {
      setItems(getItems.data);
    }
  }, [getItems.data]);

  if (getOffice.isLoading) return <Loading />;
  if (!office) return <NotFound />;

  return (
    <ItemList
      pathItems={[]}
      items={items}
      office={office}
      afterCreateItem={afterCreateItem}
      mutateItems={async () => {
        await getItems.refetch();
        setItems(getItems.data ?? []);
      }}
    />
  );
};
